import http from "app/services/httpService";
import config from "config.json";

const { apiUrl } = config;

const addCharter = async (values) => {
  try {
    const { data } = await http.post(`${apiUrl}/Supplier/flight`, values);
    return data;
  } catch (error) {
    console.log(error);
  }
};
const getAirportsDetails = async (query) => {
  const { data } = await http.get(
    `${apiUrl}/Supplier/flight/airport?searchText=${query}`
  );
  return data;
};
const getAirlineDetails = async (query) => {
  const {
    data: { data },
  } = await http.get(`${apiUrl}/Supplier/flight/carrier?searchText=${query}`);
  return data;
};

const getCharterFlights = async () => {
  const { data } = await http.get(`${apiUrl}/Supplier/flight`);
  return data;
};

const getCharterFlightById = async (id) => {
  const { data } = await http.get(`${apiUrl}/Supplier/flight/${id}`);
  return data;
};

const getcharterRequest = async (queryString) => {
  try {
    const url = `${apiUrl}/Supplier/flight${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url);
    return data;
  } catch (error) {
    throw error;
  }
};

const updateCharter = async (values) => {
  try {
    const { data } = await http.post(
      `${apiUrl}/Supplier/flight/update`,
      values
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const deleteCharter = async (id) => {
  try {
    const { data } = await http.post(`${apiUrl}/Supplier/flight/delete/${id}`);
    return data;
  } catch (error) {
    console.log(error);
  }
};
const deleteCharterRow = async (id) => {
  try {
    const { data } = await http.post(
      `${apiUrl}/Supplier/flight/delete/list/${id}`
    );
    return data;
  } catch (error) {
    console.log(error);
  }
};
const actionCharterFlight = async (value) => {
  try {
    const url = `${apiUrl}/Supplier/flight/disable-charted-flight`;
    const { data } = await http.post(url, value);
    return data;
  } catch (error) {
    throw error;
  }
};
const exportList = async (queryString) => {
  try {
    const url = `${apiUrl}/Supplier/flight/export${
      queryString ? `?${queryString}` : ""
    }`;
    const data = await http.get(url, { responseType: "blob" });
    return data;
  } catch (error) {
    throw error;
  }
};

export {
  addCharter,
  getAirportsDetails,
  getAirlineDetails,
  getCharterFlights,
  getCharterFlightById,
  getcharterRequest,
  updateCharter,
  deleteCharter,
  deleteCharterRow,
  actionCharterFlight,
  exportList,
};
